import assert from "assert"
import { GLTF } from "three/examples/jsm/Addons.js"
import * as THREE from "three/webgpu"
import { FolderApi } from "tweakpane"

export default class Buildings {
  model!: THREE.Object3D
  scene!: THREE.Scene
  debugFolder?: FolderApi

  buildingsMaterials: THREE.MeshPhysicalMaterial[] = []
  palMesh!: THREE.Mesh<THREE.PlaneGeometry, THREE.MeshPhongNodeMaterial>

  constructor({
    resources,
    scene,
    debugFolder,
  }: {
    resources: { [key: string]: GLTF }
    scene: THREE.Scene
    debugFolder?: FolderApi
  }) {
    const model = resources.blender.scene?.getObjectByName("Buildings")
    assert(model, "Model not found")

    this.model = model

    this.scene = scene
    this.debugFolder = debugFolder

    this.setup()
    this.setupDebug()
  }

  setup() {
    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        const material = child.material as THREE.MeshPhysicalMaterial
        material.emissiveIntensity = 0.1
        this.buildingsMaterials.push(material)
      }
    })

    this.scene.add(this.model)

    //
    // Lampione - TEST -
    //
    const palGeometry = new THREE.PlaneGeometry(1, 20)
    const palMaterial = new THREE.MeshPhongNodeMaterial()
    palMaterial.color = new THREE.Color("#ef105f")
    palMaterial.emissive = new THREE.Color("#ef105f")
    palMaterial.emissiveIntensity = 0.13

    this.palMesh = new THREE.Mesh(palGeometry, palMaterial)
    this.palMesh.position.set(10, 10, -50)
    this.scene.add(this.palMesh)
  }

  setupDebug() {
    if (!this.debugFolder) {
      return
    }

    const folder = this.debugFolder.addFolder({
      title: "🏢 Buildings",
      expanded: false,
    })

    const buildingsSettings = {
      emissiveIntensity: 0.1,
      palPosition: { x: 10, y: 10, z: -50 },
    }

    folder
      .addBinding(buildingsSettings, "emissiveIntensity", {
        min: 0,
        max: 1,
        step: 0.01,
      })
      .on("change", (ev) => {
        this.buildingsMaterials.forEach((material) => {
          material.emissiveIntensity = ev.value
        })
      })

    folder.addBinding(this.palMesh.material, "emissiveIntensity", {
      label: "Neon Emissive intensity",
      min: 0,
      max: 1,
      step: 0.001,
    })

    folder
      .addBinding(buildingsSettings, "palPosition", {
        x: { min: -10, max: 10, step: 0.1 },
        y: { min: -10, max: 10, step: 0.1 },
        z: { min: -50, max: 5, step: 0.1 },
      })
      .on("change", (ev) => {
        this.palMesh.position.set(ev.value.x, ev.value.y, ev.value.z)
      })
  }
}
